import { FC, useState } from "react";
import EditPencilIconSVG from "../../../resources/svg/EditPencilIconSVG";
import DeleteTrashIconSVG from "../../../resources/svg/DeleteTrashIconSVG";
import { useTranslation } from "react-i18next";
import useScreenSize from "../../../../custom-hooks/base-hooks/useScreenSize";
import { useAppDispatch } from "../../../../custom-hooks/useAppDispatch";
import { ApplicationServiceImpl } from "../../../../services/ApplicationServiceImpl";
import { ApplicationDTO } from "../../../../domain/models/dto/ApplicationDTO";
import DeleteApplication from "./DeleteApplication";
import EditApplicationPopup from "./EditApplicationPopup";
import { WorkDTO } from "../../../../domain/models/dto/WorkDTO";
import EditApplicationSuccess from "./EditApplicationSuccess";

interface ApplicationManagementButtonsProps {
    work: WorkDTO;
    application: ApplicationDTO;
    deleteApplicationCallback: () => void;
}

const ApplicationManagementButtons: FC<ApplicationManagementButtonsProps> = (props) => {
    const [isEditPopupVisible, setEditPopupVisible] = useState(false);
    const [isEditSuccessPopupVisible, setEditSuccessPopupVisible] = useState(false);
    const { upTo650, moreOrEqual650 } = useScreenSize();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const deleteApplicationHandler = async () => {
        const result = await dispatch(ApplicationServiceImpl.deleteApplicationThunk({ id: props.application.id }));
        if (result.meta.requestStatus === "fulfilled") {
            props.deleteApplicationCallback();
        }
    };

    return (
        <>
            {moreOrEqual650 && (
                <div className="flex items-center justify-center dmax2:h-[38px]">
                    <EditPencilIconSVG
                        onClick={() => setEditPopupVisible(true)}
                        className="w-8 dmax2:w-6 h-8 dmax2:h-6 text-textFaded hover:text-textWhite cursor-pointer mr-5"
                    />
                    <DeleteApplication
                        deleteApplicationHandler={deleteApplicationHandler}
                        buttonElement={
                            <DeleteTrashIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 text-textFaded hover:text-textWhite cursor-pointer" />
                        }
                    />
                </div>
            )}
            {upTo650 && (
                <div className="flex items-center justify-center mb-4">
                    <div
                        onClick={() => setEditPopupVisible(true)}
                        className="flex items-center group cursor-pointer mr-8"
                    >
                        <EditPencilIconSVG className="w-6 h-6 text-textFaded group-hover:text-textWhite mr-2" />
                        <span className="H14B text-textFaded group-hover:text-textWhite">
                            {t("work.editApplication")}
                        </span>
                    </div>
                    <DeleteApplication
                        deleteApplicationHandler={deleteApplicationHandler}
                        buttonElement={
                            <div className="flex items-center group cursor-pointer">
                                <DeleteTrashIconSVG className="w-6 h-6 text-textFaded group-hover:text-textWhite mr-2" />
                                <span className="H14B text-textFaded group-hover:text-textWhite">
                                    {t("work.deleteApplication")}
                                </span>
                            </div>
                        }
                    />
                </div>
            )}
            <EditApplicationPopup
                work={props.work}
                application={props.application}
                isEditPopupVisible={isEditPopupVisible}
                setEditPopupVisible={setEditPopupVisible}
                setEditSuccessPopupVisible={setEditSuccessPopupVisible}
            />
            <EditApplicationSuccess
                isEditSuccessPopupVisible={isEditSuccessPopupVisible}
                setEditSuccessPopupVisible={setEditSuccessPopupVisible}
            />
        </>
    );
};

export default ApplicationManagementButtons;
